
suggestedPolicies.classy.controller({
   name: 'suggestedPoliciesController',
   inject: ['$scope', '$rootScope', 'authServiceFactory'],
   init: function()
   {
   		this.$.policies = [
   			{'name': "Homemakers with no children at home during the day"},
   			{'name': "Parent that goes back to school"},
   			{'name': "Families with students in other private schools"},
   			{'name': "Families with children in college"},
   			{'name': "Families with businesses"},
   			{'name': "Giving to religious organizations"},
   			{'name': "Children of faculty"},
   			{'name': "Families with special needs children"},
   			{'name': "Families with medical conditions"},
   			{'name': "Families paying for grandparent’s medical conditions"},
   			{'name': "High auto insurance"},
   			{'name': "Divorced families"},
   			{'name': "High credit card debt"},
   			{'name': "Multiple residences"},
   			{'name': "Expensive cars"},
   			{'name': "Poor planning"},
   			{'name': "Risky endeavors"}
   		];
   }

});

